<script lang="ts">
  export let showAlt = false;
</script>

<div class="loop_switch">
  <div
    aria-hidden={showAlt ? 'true' : 'false'}
    style="visibility: {showAlt ? 'hidden' : 'visible'};"
  >
    <slot name="main" />
  </div>
  <div
    aria-hidden={showAlt ? 'false' : 'true'}
    class="loop_alt"
    style={showAlt ? 'opacity: 1; pointer-events: all' : 'visibility: hidden'}
  >
    {#if showAlt}
      <slot name="alt" />
    {/if}
  </div>
</div>

<style>
  .loop_switch {
    position: relative;
  }

  .loop_alt {
    background: var(--loop-background);
    position: absolute;
    top: 0px;
    left: 0px;
    right: 0px;
    bottom: 0px;
    opacity: 0;
    pointer-events: none;
    transition: all 0.45s;
  }
</style>
